import { render, staticRenderFns } from "./cultivation.vue?vue&type=template&id=9533eee8&scoped=true&"
import script from "./cultivation.vue?vue&type=script&lang=ts&"
export * from "./cultivation.vue?vue&type=script&lang=ts&"
import style0 from "./cultivation.vue?vue&type=style&index=0&id=9533eee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9533eee8",
  null
  
)

export default component.exports